var _defs, _line, _line2, _line3, _line4, _line5, _rect, _line6, _rect2, _line7, _rect3, _line8, _rect4, _line9, _rect5, _polyline, _polygon, _line0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrotrader(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt-bull",
    x1: 0,
    y1: 1,
    x2: 0,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a4a7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5ab4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mt-trend",
    x1: 0,
    y1: 1,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2980b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#85d4ff"
  })))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 58,
    x2: 176,
    y2: 58,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 88,
    x2: 176,
    y2: 88,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 118,
    x2: 176,
    y2: 118,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 148,
    x2: 176,
    y2: 148,
    stroke: "white",
    strokeOpacity: 0.06,
    strokeWidth: 1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 45,
    y1: 126,
    x2: 45,
    y2: 158,
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 1.5
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 131,
    width: 14,
    height: 22,
    fill: "#c0392b",
    fillOpacity: 0.82,
    rx: 1.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 73,
    y1: 99,
    x2: 73,
    y2: 136,
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 104,
    width: 14,
    height: 27,
    fill: "url(#mt-bull)",
    rx: 1.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 101,
    y1: 71,
    x2: 101,
    y2: 112,
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94,
    y: 77,
    width: 14,
    height: 30,
    fill: "url(#mt-bull)",
    rx: 1.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 129,
    y1: 69,
    x2: 129,
    y2: 100,
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 1.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 73,
    width: 14,
    height: 19,
    fill: "#c0392b",
    fillOpacity: 0.82,
    rx: 1.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 157,
    y1: 43,
    x2: 157,
    y2: 83,
    stroke: "white",
    strokeOpacity: 0.28,
    strokeWidth: 1.5
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 150,
    y: 49,
    width: 14,
    height: 29,
    fill: "url(#mt-bull)",
    rx: 1.5
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "45,142 73,117 101,92 129,82 157,63",
    stroke: "url(#mt-trend)",
    strokeWidth: 2.5,
    strokeOpacity: 0.92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "165,53 159,67 150,60",
    fill: "#85d4ff",
    fillOpacity: 0.95
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 24,
    y1: 163,
    x2: 176,
    y2: 163,
    stroke: "white",
    strokeOpacity: 0.14,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrotrader);
export default __webpack_public_path__ + "static/media/microtrader.2e45c253556e597f664d708ec296adda.svg";
export { ForwardRef as ReactComponent };